import { Button } from "@blueprintjs/core";
import React, { Component } from 'react';
import { DragSource } from 'react-dnd';
import { PMDNDTypes } from "./constants";
import '../projectmanager/PMWindowedApp.css';

class Scaffold extends Component {

	render() {
		const { window } = this.props;
		const { xLeft, yTop, size_h, size_w, zIndex, buttons } = window;

		const winStyle = {
			top: yTop,
			left: xLeft,
			width: size_w,
			zIndex: zIndex
		}

		return (
			<div className="PMWindow" style={winStyle}>
				{this.header()}
				{this.body()}
				{buttons ? this.footer() : null}
			</div>
		)
	}

	header = () => {
		const { connectDragSource, index, window, data, funcClose, funcLock, color } = this.props;
		const { xLeft, yTop, zIndex } = window; // DEBUG
		const headStyle = {
			backgroundImage: 'linear-gradient(to right, ' + color + ', white)',
		}

		return connectDragSource(
			<div className="PMWindowHeader" style={headStyle} >
				<div className="PMWindowHeaderLeft">
					<Button icon="lock" onClick={() => funcLock(index)} />
				</div>

				{data.title + ' x: ' + xLeft + ' y: ' + yTop}

				<div className="PMWindowHeaderRight">
					<Button icon="cross" onClick={funcClose} />
				</div>
			</div>
		)
	}


	body() {
		const { fieldData, handleChange, index } = this.props;
		return (
			<div className={"PMWindowContent" + " pm-uncollapse"} >
				{fieldData.map(
					(fd, findex) =>
						<div key={fd.index + fd.label}>
							{fd.label}
							<br />
							<input key={fd.label} type="text" name={fd.label} value={fd.value} onChange={(event) => handleChange(index, findex, event)} />
							<br />
						</div>
				)}
				{this.props.children}
			</div>
		)
	}

	footer() {
		const { funcAction, window } = this.props;
		const { actions, buttons } = window;
		return (
			<div className="PMWindowFooter">
				{buttons.map(
					(bt, index) =>
						<span key={index + bt}>
							<Button onClick={() => funcAction(actions[index])}> {bt} </Button>
						</span>
				)}
			</div>
		)
	}

}

const dragSource = {
	beginDrag: function (props, monitor, component) {
		//console.log("beginDrag");
		return props
	},
	isDragging: function (props, monitor, component) {
		//console.log("dragging");
	},
	endDrag: function (props, monitor, component) {
		//console.log("endDrag")
	}
}

function dragCollect(connect, monitor, component) {
	return {
		connectDragSource: connect.dragSource(),
		connectDragPreview: connect.dragPreview(),
		isDragging: monitor.isDragging(),
	}
}

Scaffold = DragSource(PMDNDTypes.WINDOW, dragSource, dragCollect)(Scaffold);
export default Scaffold;


// WEBPACK FOOTER //
// ./src/components/scaffold/Scaffold.js